import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/Volumes/4TB-PRO-BLADE/projects/mvpProject/website/mvp-website-new/layouts/default.vue").then(m => m.default || m))
}